import React, { Component } from "react";
import Layout from "layouts/DashboardManage";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import hasProperty from "lodash/has";
import SubmitButton from "components/Forms/Buttons/Submit";
import Notification, { notifyApiError } from "components/Notification";
import { getAllMetadata, addMetadata } from "store/actions/metadataAction";
import Textbox from "components/Forms/Elements/Textbox";
import AutoSuggest from "components/Forms/Elements/AutoSuggest";
import Translate from "helpers/Translate";

export class Metadata extends Component {
  state = {
    title: "",
    metadataId: ""
  };

  componentDidMount() {
    this.props.getAllMetadata({});
  }

  componentDidUpdate(prevProps) {
    // When the new metadata is created successfully, we will redirect to step 2
    if (
      prevProps.addMetadataResponse !== this.props.addMetadataResponse &&
      hasProperty(this, "props.addMetadataResponse.id")
    ) {
      // Redirect to to step 2
      this.props.history.push(
        `/manage/metadata/edit/${this.props.addMetadataResponse.id}`
      );
    }

    // When there was a problem creating the new metadata
    if (
      prevProps.errorMetadata !== this.props.errorMetadata &&
      this.props.errorMetadata &&
      Object.keys(this.props.errorMetadata).length > 0
    ) {
      notifyApiError(this.props.errorMetadata);
    }
  }

  handleChange = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  handleCreate = () => {
    this.props.addMetadata({
      title: this.state.title
    });
  };

  handleUpdate = e => {
    e.preventDefault();
    if (!this.state.metadataId) {
      Notification.error(
        Translate({ id: "please_select_a_valid_metadata_first" })
      );
    } else {
      // Redirect to Edit Page
      this.props.history.push(`/manage/metadata/edit/${this.state.metadataId}`);
    }
  };

  render() {
    return (
      <Layout>
        <div className="meta-data">
          <h1 className="title mb-30">
            {Translate({ id: "add_edit_metadata" })}{" "}
          </h1>
          <div className="tabs">
            <div className="tab tab-manage selected">
              {Translate({ id: "step_1_manage_meta_data" })}
            </div>
            <div className="tab tab-design selected1">
              {Translate({ id: "step_2_input_field_designer" })}
            </div>
            <div className="tab tab-design selected">
              {Translate({ id: "step_3_folder_path_designer" })}
            </div>
            <div className="tab tab-design selected">
              {Translate({ id: "step_4_file_name_designer" })}
            </div>
          </div>

          <div className="tab-wrapper">
            <div className="tab-manage-wrapper selected">
              <div className="new">
                <h2 className="title mb-30">
                  {Translate({ id: "create_a_new_meta_data" })}{" "}
                </h2>
                <div className="input-wrapper mb-20">
                  <label htmlFor="title">
                    {Translate({ id: "new_metadata_title" })}{" "}
                  </label>
                  <Textbox
                    type="text"
                    placeholder={Translate({ id: "my_contracts" })}
                    id="title"
                    name="title"
                    fieldValue={this.state.title}
                    onChange={this.handleChange}
                    onReturnKey={this.handleCreate}
                    errors={this.props.errorMetadata}
                    errorKey="title"
                    formErrorClass="form-error-inverse"
                  />
                  <div className="help mt-5">
                    {Translate({
                      id: "human_friendly_name_for_the_metadata"
                    })}
                  </div>
                </div>
                <SubmitButton
                  className="btn btn-default-light btn-full"
                  buttonIconClass="fas fa-save"
                  buttonText={Translate({ id: "save_and_next" })}
                  btnId="create"
                  isLoading={this.props.isLoading}
                  handleSubmit={this.handleCreate}
                />
              </div>

              <div>
                <span>{Translate({ id: "or", uppercase: true })} </span>
              </div>

              <div className="update">
                <h2 className="title mb-30">
                  {Translate({ id: "edit_existing_metadata" })}{" "}
                </h2>

                <div className="input-wrapper mb-20">
                  <label htmlFor="autosuggest">
                    {Translate({ id: "type_to_search_for_a_metadata" })}
                  </label>
                  <AutoSuggest
                    data={
                      hasProperty(this, "props.getAllMetadataResponse.data")
                        ? this.props.getAllMetadataResponse.data
                        : []
                    }
                    keyword={value => {
                      this.props.getAllMetadata({ title: value });
                      this.setState({ metadataId: "" });
                    }}
                    displayItemInList="title"
                    onSelect={selectedItem =>
                      this.setState({ metadataId: selectedItem.id })
                    }
                  />
                </div>
                <SubmitButton
                  className="btn btn-default-light btn-full"
                  buttonIconClass="fas fa-arrow-circle-right"
                  buttonText={Translate({ id: "next" })}
                  btnId="update"
                  handleSubmit={this.handleUpdate}
                />
              </div>
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}

Metadata.propTypes = {
  getAllMetadata: PropTypes.func.isRequired,
  addMetadata: PropTypes.func.isRequired,
  metadata: PropTypes.object,
  isLoading: PropTypes.bool,
  getAllMetadataResponse: PropTypes.object,
  addMetadataResponse: PropTypes.object,
  errorMetadata: PropTypes.object
};

const mapStateToProps = state => {
  return {
    getAllMetadataResponse: state.metadata.getAllMetadata,
    addMetadataResponse: state.metadata.addMetadata,
    errorMetadata: state.metadata.errorMetadata,
    isLoading: state.metadata.isLoadingMetadata
  };
};

export default connect(mapStateToProps, { getAllMetadata, addMetadata })(
  Metadata
);
